import type { TrackingFn } from '@change-corgi/core/react/tracking';

type MovementPageShareParams = {
	movementId: string;
	location: string;
	viewContext: string;
	context: string;
};

export async function trackMovementPageView(
	movementId: string,
	sourceLocation: string,
	viewContext: string,
	track: TrackingFn,
): Promise<boolean> {
	const eventName = 'movement_view';
	const eventOptions = { movement_id: movementId, source_location: sourceLocation, view_context: viewContext };
	return track(eventName, eventOptions);
}

export async function trackMovementPageShare(params: MovementPageShareParams, track: TrackingFn): Promise<boolean> {
	const eventName = 'movement_share';
	const eventOptions = {
		movement_id: params.movementId,
		location: params.location,
		context: params.context,
		view_context: params.viewContext,
	};
	return track(eventName, eventOptions);
}

export async function trackMovementPetitionClick(
	movementId: string,
	petitionId: string,
	viewContext: string,
	track: TrackingFn,
): Promise<boolean> {
	const eventName = 'movement_petition_click';
	const eventOptions = { movement_id: movementId, petition_id: petitionId, view_context: viewContext };
	return track(eventName, eventOptions);
}

export async function trackMovementEditClick(
	movementId: string,
	viewContext: string,
	track: TrackingFn,
): Promise<boolean> {
	const eventName = 'movement_edit_click';
	const eventOptions = { movement_id: movementId, view_context: viewContext };
	return track(eventName, eventOptions);
}

export async function trackMovementAddPetitionsClick(
	movementId: string,
	viewContext: string,
	track: TrackingFn,
): Promise<boolean> {
	const eventName = 'movement_add_petitions_click';
	const eventOptions = { movement_id: movementId, view_context: viewContext };
	return track(eventName, eventOptions);
}
